<div id="attribute">
    <div class="title-head" fxLayout="row" fxLayoutAlign="space-between center" color="primary">
        <span>
            Edit
        </span>
        <button [attr.guide]="'popup-edit-btn-1' + '__' + sanitizeUrl(url)" mat-icon-button>
            <mat-icon (click)="close()">
                close
            </mat-icon>
        </button>
    </div>
    <div class="padding-11" style="overflow-x: auto;">
        <div fxLayout="column" [formGroup]="firstFormGroup">

            <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px">


                <mat-form-field *ngIf="key=='company'" fxFlex appearance="outline">
                    <mat-label>{{key}}</mat-label>
                    <input [attr.guide]="'popup-edit-inp-value' + '__' + sanitizeUrl(url)" matInput
                        formControlName="value" (input)="getCompanyData(firstFormGroup.value.value)"
                        [matAutocomplete]="auto" [readonly]="isOptionSelected||element.companyId> 0 "
                        placeholder="Enter Company" />
                    <mat-icon *ngIf="isOptionSelected||element.companyId>0 " matSuffix (click)="clearInputCompany()"
                        style="cursor: pointer;">clear</mat-icon>

                    <mat-autocomplete #auto="matAutocomplete">
                        <mat-option (onSelectionChange)="onCompanySelected($event,opt,element)"
                            *ngFor="let opt of companyList" [value]="opt.name">
                            {{ opt.name }}
                        </mat-option>
                        <mat-option *ngIf="companyList?.length === 0" disabled>
                            No company found
                        </mat-option>
                    </mat-autocomplete>


                </mat-form-field>

                <mat-form-field *ngIf="key!='company'" fxFlex appearance="outline">
                    <mat-label>{{key === 'tagName' || key === 'Tags' ? 'Tag Name' : key}}</mat-label>
                    <input [attr.guide]="'popup-edit-inp-value' + '__' + sanitizeUrl(url)"
                        *ngIf="inputType === 'text' && key !== 'tagName' && key !== 'Tags'"
                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur" matInput
                        formControlName="value" />

                    <mat-select *ngIf="inputType === 'select' && key !== 'tagName' && key !== 'Tags'"
                        formControlName="value">

                        <ng-container *ngIf="key == 'ownerEmail'">
                            <mat-option (onSelectionChange)="onOwnerSelected($event,opt,element)"
                                *ngFor="let opt of filtereduserTypeList; let i=index;" [value]="opt.email">
                                {{opt.email}}
                            </mat-option>
                        </ng-container>

                        <ng-container *ngIf="key == 'statusName'">
                            <mat-option *ngFor="let opt of filteredleadStatusTypeList; let i=index;"
                                [value]="opt.statusId">
                                {{opt.statusName}}
                            </mat-option>
                        </ng-container>


                        <ng-container *ngIf="key == 'sourceName'">
                            <mat-option *ngFor="let opt of filteredLeadSourceTypeList; let i=index;"
                                [value]="opt.sourceId">
                                {{opt.sourceName}}
                            </mat-option>
                        </ng-container>

                    </mat-select>

                    <mat-select *ngIf="key == 'tagName' || key == 'Tags'" formControlName="value">
                        <mat-option *ngFor="let opt of filteredtagsTypeList; let i=index;" [value]="opt.statusName">
                            {{opt.statusName}}
                        </mat-option>
                    </mat-select>

                </mat-form-field>

            </div>

        </div>
        <div class="padding-top10 " fxLayoutGap="10px">
            <button [attr.guide]="'popup-edit-btn-3' + '__' + sanitizeUrl(url)" type="button" mat-raised-button
                (click)="save()">Save
            </button>
            <button [attr.guide]="'popup-edit-btn-4' + '__' + sanitizeUrl(url)" type="button" mat-raised-button
                (click)="close()">Cancel
            </button>
        </div>
    </div>
</div>